import classNames from 'classnames/bind';
import parse from 'html-react-parser';
import { type ImageProps as ImageType } from 'next/image';
import { CSSProperties } from 'react';
import { Img as ImageComp } from '../../elements/Img';
import styles from './index.module.scss';

type Image = {
  id: string;
  width?: number | string;
  height?: number | string;
};

export type ImageProps = {
  image: Image | string;
  text?: string;
  crop?: {
    ratio?: number;
    position?: {
      x: number;
      y: number;
    };
  };
  [key: string]: any;
};

export const Image = ({ image, text, crop, ...rest }: ImageProps) => {
  const cx = classNames.bind(styles);
  const props = {} as ImageType;

  if (!image) return null;

  console.log(image);

  return (
    <figure
      className={cx('component', 'image', rest)}
      style={
        {
          '--ratio': crop?.ratio || undefined,
          '--left': crop?.position?.x ? Math.abs(crop?.position?.x) : undefined,
          '--top': crop?.position?.y ? Math.abs(crop?.position?.y) : undefined,
        } as CSSProperties
      }
    >
      <div className={cx('wrapper', { crop: !!crop })}>
        {image && (
          <div className={styles.img}>
            <ImageComp
              src={typeof image == 'object' ? image.id : image}
              width={
                rest.slides
                  ? undefined
                  : typeof image == 'object'
                    ? image.width
                    : 0
              }
              height={
                rest.slides
                  ? undefined
                  : typeof image == 'object'
                    ? image.height
                    : 0
              }
              fill={!!rest.slides}
            />
          </div>
        )}
      </div>
      {!!text && text !== '<p><br/></p>' && (
        <figcaption className={`${styles.caption}`}>{parse(text)}</figcaption>
      )}
    </figure>
  );
};

Image.defaultProps = {
  picture: [],
} as Partial<ImageProps>;
